import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import {ModalHeader, ModalContent, ModalFooter,ContentItem,Dropdown} from '@gnb/components/Common'
import PreferenceContentTemplate from '@gnb/templates/PreferenceContentTemplate.vue'
import DatePicker  from '@appbase/components/DatePicker/DatePicker.vue'
import * as dateutil from '@appbase/util/date-helper'
import api from '@gnb/api/common'
import CheckSlider from '@gnb/components/Common/CheckSlider.vue'
import { mapActions } from 'vuex'
import * as types from '@gnb/store/types'

@Component({
    components:{
        CheckSlider,
        ModalHeader,
        ModalContent,
        ModalFooter,
        ContentItem,
        PreferenceContentTemplate,
        Dropdown,
        DatePicker
    },
    methods:{
        ...mapActions({
            loading: types.COMMON_LOADDING
        })
    },
})
export default class SettingMissedTime extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Object }) value!: gnb.MissedAutoReplyItem;
    
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    loading!: (option: boolean) => void;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    isEnabled: boolean = false;
    startTimeArray: Array<any> = [];
    endTimeArray: Array<any> = [];
    label: string = this.$t('부재중_설정_사용').toString();
    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    /**
     * 시작일자 배열을 가져옵니다
     */
    get StartTimeArray() {
    this.startTimeArray.sort((a, b) => a.num - b.num);
    return this.startTimeArray;
    }
    /**
     * 시작일자를 직접 입력했을 경우에 동작합니다
     */
    set StartTimeArray(value) {
        this.startTimeArray = value;
    }
    /**
     * 완료일자 배열을 표시합니다
     */
    get EndTimeArray() {
        this.endTimeArray.sort((a, b) => a.num - b.num);
        return this.endTimeArray;
    }
    /**
     * 완료일자를 직접 입력했을 경우에 동작합니다
     */
    set EndTimeArray(value) {
        this.endTimeArray = value;
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    checkDate(startDate: string, endDate: string) {
        if(!this.value.checkUseAutoReply)
            return true;
            
        const now = new Date();
    
        if (startDate >= endDate) {
            (window as any).alertAsync(this.$t('M_Settings_Msg37'));
            return false;
        }
        if (new Date(endDate) <= now) {
            (window as any).alertAsync(this.$t('M_Settings_Msg38'));
            return false;
        }
    
        return true;
    }

    changeDate(dateTime: string, type: string = '') {
        const offset = new Date().getTimezoneOffset();
        let date = dateutil.IEDate(dateTime);
        if (type === 'UTC') {
            date.setMinutes(date.getMinutes() + offset);
        } else {
            date.setMinutes(date.getMinutes() - offset);
        }
        return dateutil.uGetDateFormat(
            'yyyy-MM-DD H:i:s',
            dateutil.IEDate(date)
        );
    }   

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    mounted(){
        this.startTimeArray = dateutil.uGetTimeArray([
            this.$t('W_AM').toString(),
            this.$t('W_PM').toString(),
        ]);
        this.endTimeArray = dateutil.uGetTimeArray([
            this.$t('W_AM').toString(),
            this.$t('W_PM').toString(),
        ]);
    }

 
    getValue(): { enabled: boolean, start: string, end: string } | null {
        let startDateTime = this.value.start + ' ' + this.value.starttime;
        let endDateTime = this.value.end + ' ' + this.value.endtime;

        if(this.checkDate(startDateTime, endDateTime)) {
            return {
                enabled: this.value.checkUseAutoReply,
                start: startDateTime,
                end: endDateTime
            }
        } else {
            return null;
        }        
    }
}